module.exports = __webpack_public_path__ + "static/capo-2280b26ed1d6334e6503334c505fb7f2.png";